import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { ByobService } from 'src/app/services/byob.service';
import { CartService } from 'src/app/services/cart.service';

import { Product } from 'src/app/models/product.model';

@Component({
  selector: 'app-byob',
  templateUrl: './byob.component.html',
  styleUrls: ['./byob.component.css']
})
export class ByobComponent implements OnInit {

  isLoading = false;

  // Products
  boxes: any[] = [];
  books: any[] = [];
  bookmarks: any[] = [];
  badges: any[] = [];
  crochets: any[] = [];
  stationery: any[] = [];

  // Selected Products
  selectedBox: any = null;

  selectedBooks: any[] = [];
  selectedBookmarks: any[] = [];
  selectedBadges: any[] = [];
  selectedCrochets: any[] = [];
  selectedStationery: any[] = [];

  // Minimum Required
  readonly minBooks = 3;
  readonly minBookmarks = 3;
  readonly minBadges = 1;
  readonly minCrochets = 1;
  readonly minStationery = 3;

  currentByobBox: any = null;
  byobBoxId!: number;

  showSuccessMessage = false;
  boxMessage = '';

  constructor(
    private byobService: ByobService,
    private cartService: CartService,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.loadProducts();

  }

  loadProducts(): void {

    this.isLoading = true;

    this.byobService.getAvailableItems().subscribe({

      next: (res: any) => {

        this.isLoading = false;

        if (!res.status) {
          return;
        }

        this.boxes = res.data.boxes || [];
        this.books = res.data.books || [];
        this.bookmarks = res.data.bookmarks || [];
        this.badges = res.data.badges || [];
        this.crochets = res.data.crochets || [];
        this.stationery = res.data.stationery || [];

        this.boxes.forEach(x => x.selected = false);
        this.books.forEach(x => x.selected = false);
        this.bookmarks.forEach(x => x.selected = false);
        this.badges.forEach(x => x.selected = false);
        this.crochets.forEach(x => x.selected = false);
        this.stationery.forEach(x => x.selected = false);

        this.createNewByobBox();

      },

      error: () => {

        this.isLoading = false;

      }

    });

  }

  createNewByobBox(): void {

    this.byobService.createByobBox().subscribe({

      next: (res: any) => {

        if (res.status) {

          this.currentByobBox = res.data;

          this.byobBoxId = res.data.id;

        }

      }

    });

  }
  /*----------------------------------------------------
SELECT GIFT BOX
----------------------------------------------------*/

  selectBox(box: any): void {

    this.boxes.forEach(x => x.selected = false);

    box.selected = true;

    this.selectedBox = box;

    // Reset all selections
    this.selectedBooks = [];
    this.selectedBookmarks = [];
    this.selectedBadges = [];
    this.selectedCrochets = [];
    this.selectedStationery = [];

    this.books.forEach(x => x.selected = false);
    this.bookmarks.forEach(x => x.selected = false);
    this.badges.forEach(x => x.selected = false);
    this.crochets.forEach(x => x.selected = false);
    this.stationery.forEach(x => x.selected = false);

    // Save selected box
    this.byobService
      .addItemToBox(this.byobBoxId, box.id)
      .subscribe();

  }

  /*----------------------------------------------------
  COMMON TOGGLE METHOD
  ----------------------------------------------------*/

  private toggleSelection(
    item: any,
    selectedArray: any[]
  ): void {

    item.selected = !item.selected;

    if (item.selected) {

      selectedArray.push(item);

      this.byobService
        .addItemToBox(
          this.byobBoxId,
          item.id
        )
        .subscribe();

    } else {

      const index =
        selectedArray.findIndex(
          x => x.id === item.id
        );

      if (index > -1) {

        selectedArray.splice(index, 1);

      }

      this.byobService
        .removeItemFromBox(
          this.byobBoxId,
          item.id
        )
        .subscribe();

    }

  }

  /*----------------------------------------------------
  BOOKS
  ----------------------------------------------------*/

  toggleBook(book: any): void {

    this.toggleSelection(
      book,
      this.selectedBooks
    );

  }

  /*----------------------------------------------------
  BOOKMARK
  ----------------------------------------------------*/

  toggleBookmark(bookmark: any): void {

    this.toggleSelection(
      bookmark,
      this.selectedBookmarks
    );

  }

  /*----------------------------------------------------
  BADGE
  ----------------------------------------------------*/

  toggleBadge(badge: any): void {

    this.toggleSelection(
      badge,
      this.selectedBadges
    );

  }

  /*----------------------------------------------------
  CROCHET
  ----------------------------------------------------*/

  toggleCrochet(crochet: any): void {

    this.toggleSelection(
      crochet,
      this.selectedCrochets
    );

  }

  /*----------------------------------------------------
  STATIONERY
  ----------------------------------------------------*/

  toggleStationery(item: any): void {

    this.toggleSelection(
      item,
      this.selectedStationery
    );

  }

  /*----------------------------------------------------
  SECTION VISIBILITY
  ----------------------------------------------------*/

  canSelectBooks(): boolean {

    return this.selectedBox != null;

  }

  canSelectBookmarks(): boolean {

    return this.selectedBooks.length >= this.minBooks;

  }

  canSelectBadges(): boolean {

    return this.selectedBookmarks.length >= this.minBookmarks;

  }

  canSelectCrochets(): boolean {

    return this.selectedBadges.length >= this.minBadges;

  }

  canSelectStationery(): boolean {

    return this.selectedCrochets.length >= this.minCrochets;

  }
  /*----------------------------------------------------
TOTAL PRICE
----------------------------------------------------*/

  get totalPrice(): number {

    let total = 0;

    const calculate = (items: any[]) => {

      items.forEach(item => {

        total += Number(
          item.special_price ||
          item.mrp_price ||
          0
        );

      });

    };

    if (this.selectedBox) {

      total += Number(
        this.selectedBox.special_price ||
        this.selectedBox.mrp_price ||
        0
      );

    }

    calculate(this.selectedBooks);
    calculate(this.selectedBookmarks);
    calculate(this.selectedBadges);
    calculate(this.selectedCrochets);
    calculate(this.selectedStationery);

    return total;

  }

  /*----------------------------------------------------
  REMOVE SELECTED BOX
  ----------------------------------------------------*/

  removeSelectedBox(): void {

    if (!this.selectedBox) {
      return;
    }

    this.byobService
      .removeItemFromBox(
        this.byobBoxId,
        this.selectedBox.id
      )
      .subscribe();

    this.selectedBox.selected = false;
    this.selectedBox = null;

    this.resetSelections();

  }

  /*----------------------------------------------------
  REMOVE BOOK
  ----------------------------------------------------*/

  removeBook(book: any): void {

    this.removeSelection(
      book,
      this.selectedBooks
    );

  }

  /*----------------------------------------------------
  REMOVE BOOKMARK
  ----------------------------------------------------*/

  removeBookmark(bookmark: any): void {

    this.removeSelection(
      bookmark,
      this.selectedBookmarks
    );

  }

  /*----------------------------------------------------
  REMOVE BADGE
  ----------------------------------------------------*/

  removeBadge(badge: any): void {

    this.removeSelection(
      badge,
      this.selectedBadges
    );

  }

  /*----------------------------------------------------
  REMOVE CROCHET
  ----------------------------------------------------*/

  removeCrochet(crochet: any): void {

    this.removeSelection(
      crochet,
      this.selectedCrochets
    );

  }

  /*----------------------------------------------------
  REMOVE STATIONERY
  ----------------------------------------------------*/

  removeStationery(item: any): void {

    this.removeSelection(
      item,
      this.selectedStationery
    );

  }

  /*----------------------------------------------------
  COMMON REMOVE FUNCTION
  ----------------------------------------------------*/

  private removeSelection(
    item: any,
    selectedArray: any[]
  ): void {

    this.byobService
      .removeItemFromBox(
        this.byobBoxId,
        item.id
      )
      .subscribe();

    item.selected = false;

    const index = selectedArray.findIndex(
      x => x.id === item.id
    );

    if (index > -1) {

      selectedArray.splice(index, 1);

    }

  }

  /*----------------------------------------------------
  RESET ALL SELECTIONS
  ----------------------------------------------------*/

  private resetSelections(): void {

    this.selectedBooks = [];
    this.selectedBookmarks = [];
    this.selectedBadges = [];
    this.selectedCrochets = [];
    this.selectedStationery = [];

    this.books.forEach(x => x.selected = false);
    this.bookmarks.forEach(x => x.selected = false);
    this.badges.forEach(x => x.selected = false);
    this.crochets.forEach(x => x.selected = false);
    this.stationery.forEach(x => x.selected = false);

  }

  /*----------------------------------------------------
  REFRESH CURRENT BOX
  ----------------------------------------------------*/

  updateCurrentByobBox(): void {

    if (!this.byobBoxId) {
      return;
    }

    this.byobService
      .getByobBox(this.byobBoxId)
      .subscribe({

        next: (res: any) => {

          if (res.status) {

            this.currentByobBox = res.data;

          }

        }

      });

  }  /*----------------------------------------------------
  BUILD DESCRIPTION
  ----------------------------------------------------*/

  buildDescription(): string {

    let description = '';

    if (this.selectedBox) {

      description += 'Gift Box:\n';
      description += '- ' + this.selectedBox.name + '\n\n';

    }

    const appendItems = (title: string, items: any[]) => {

      if (!items.length) {
        return;
      }

      description += title + ':\n';

      items.forEach((item, index) => {

        description += `${index + 1}. ${item.name}\n`;

      });

      description += '\n';

    };

    appendItems('Books', this.selectedBooks);
    appendItems('Bookmarks', this.selectedBookmarks);
    appendItems('Badges', this.selectedBadges);
    appendItems('Crochets', this.selectedCrochets);
    appendItems('Stationery', this.selectedStationery);

    return description;

  }

  /*----------------------------------------------------
  SELECTED ITEM NAMES
  ----------------------------------------------------*/

  getSelectedNames(): string[] {

    const names: string[] = [];

    if (this.selectedBox) {

      names.push(this.selectedBox.name);

    }

    this.selectedBooks.forEach(x => names.push(x.name));
    this.selectedBookmarks.forEach(x => names.push(x.name));
    this.selectedBadges.forEach(x => names.push(x.name));
    this.selectedCrochets.forEach(x => names.push(x.name));
    this.selectedStationery.forEach(x => names.push(x.name));

    return names;

  }

  /*----------------------------------------------------
  RESET BUILDER
  ----------------------------------------------------*/

  resetBuilder(): void {

    this.selectedBox = null;

    this.currentByobBox = null;

    this.boxes.forEach(x => x.selected = false);

    this.resetSelections();

  }

  /*----------------------------------------------------
  CHECKOUT VALIDATION
  ----------------------------------------------------*/

  canCheckout(): boolean {

    return !!this.selectedBox

      && this.selectedBooks.length >= this.minBooks

      && this.selectedBookmarks.length >= this.minBookmarks

      && this.selectedBadges.length >= this.minBadges

      && this.selectedCrochets.length >= this.minCrochets

      && this.selectedStationery.length >= this.minStationery;

  }

  /*----------------------------------------------------
  ADD TO CART
  ----------------------------------------------------*/

  addToCart(): void {

    if (!this.canCheckout()) {

      alert(
        'Please complete your gift box before adding it to the cart.'
      );

      return;
    }

    /*
    |--------------------------------------------------------------------------
    | GET ALL BYOB PRODUCT IDS
    |--------------------------------------------------------------------------
    */

    const byobProductIds = this.getByobProductIds();

    if (!byobProductIds.length) {

      alert(
        'Unable to identify the selected BYOB products.'
      );

      return;
    }

    console.log(
      'BYOB PRODUCT IDS:',
      byobProductIds
    );


    /*
    |--------------------------------------------------------------------------
    | IMPORTANT
    |
    | Your checkout/cart payload currently keeps:
    | id, name, tamil_name, sku, thumbnail_image
    |
    | But it removes custom "options".
    |
    | Therefore we encode the actual product IDs into SKU.
    |
    | Example:
    | BYOB:12,25,26,27,35,36,37,42,51,61,62,63
    |--------------------------------------------------------------------------
    */

    const byobSku =
      'BYOB:' + byobProductIds.join(',');


    /*
    |--------------------------------------------------------------------------
    | BYOB IMAGE
    |--------------------------------------------------------------------------
    */

    const byobImage =
      this.selectedBox?.thumbnail_image_full_url || '';

    /*
    |--------------------------------------------------------------------------
    | CREATE BYOB PRODUCT
    |--------------------------------------------------------------------------
    */

    const byobProduct: Product = {

      id: 0,

      status: 1,

      name: 'Build Your Own Box',

      tamil_name: 'Build Your Own Box',

      short_description: [
        'Custom Gift Box'
      ],

      description:
        this.buildDescription(),

      mrp_price:
        this.totalPrice.toFixed(2),

      special_price:
        this.totalPrice.toFixed(2),

      offers:
        this.totalPrice.toFixed(2),

      thumbnail_image:
        byobImage,

      categories: [
        'BYOB'
      ],

      tag:
        'byob',

      is_international:
        0,

      images: [
        {
          id: 0,
          product_id: 0,
          image_url: byobImage,
          is_thumbnail: true,
          order_priority: 1
        }
      ],

      stock_quantity: 1,

      in_stock: true,

      /*
      |--------------------------------------------------------------------------
      | IMPORTANT
      |--------------------------------------------------------------------------
      */

      sku: byobSku,

      options: {

        is_byob_box: true,

        byob_box_id:
          this.byobBoxId,

        selected_box:
          Number(this.selectedBox.id),

        selected_books:
          this.selectedBooks.map(
            x => Number(x.id)
          ),

        selected_bookmarks:
          this.selectedBookmarks.map(
            x => Number(x.id)
          ),

        selected_badges:
          this.selectedBadges.map(
            x => Number(x.id)
          ),

        selected_crochets:
          this.selectedCrochets.map(
            x => Number(x.id)
          ),

        selected_stationery:
          this.selectedStationery.map(
            x => Number(x.id)
          ),

        product_ids:
          byobProductIds,

        selected_item_names:
          this.getSelectedNames()
      }
    };


    /*
    |--------------------------------------------------------------------------
    | DEBUG
    |--------------------------------------------------------------------------
    */

    console.log(
      'BYOB PRODUCT:',
      byobProduct
    );

    console.log(
      'BYOB SKU:',
      byobProduct.sku
    );


    /*
    |--------------------------------------------------------------------------
    | ADD TO CART
    |--------------------------------------------------------------------------
    */

    this.cartService.addToCart(
      byobProduct,
      1
    );


    /*
    |--------------------------------------------------------------------------
    | RESET
    |--------------------------------------------------------------------------
    */

    this.resetBuilder();

    this.createNewByobBox();


    /*
    |--------------------------------------------------------------------------
    | GO TO CART
    |--------------------------------------------------------------------------
    */

    this.router.navigate([
      '/cart'
    ]);
  }


  /*----------------------------------------------------
  GET ALL BYOB PRODUCT IDS
  ----------------------------------------------------*/

  getByobProductIds(): number[] {

    const ids: number[] = [];


    /*
    |--------------------------------------------------------------------------
    | Gift Box
    |--------------------------------------------------------------------------
    */

    if (this.selectedBox?.id) {

      ids.push(
        Number(this.selectedBox.id)
      );
    }


    /*
    |--------------------------------------------------------------------------
    | Books
    |--------------------------------------------------------------------------
    */

    this.selectedBooks.forEach(item => {

      if (item?.id) {

        ids.push(
          Number(item.id)
        );
      }

    });


    /*
    |--------------------------------------------------------------------------
    | Bookmarks
    |--------------------------------------------------------------------------
    */

    this.selectedBookmarks.forEach(item => {

      if (item?.id) {

        ids.push(
          Number(item.id)
        );
      }

    });


    /*
    |--------------------------------------------------------------------------
    | Badges
    |--------------------------------------------------------------------------
    */

    this.selectedBadges.forEach(item => {

      if (item?.id) {

        ids.push(
          Number(item.id)
        );
      }

    });


    /*
    |--------------------------------------------------------------------------
    | Crochets
    |--------------------------------------------------------------------------
    */

    this.selectedCrochets.forEach(item => {

      if (item?.id) {

        ids.push(
          Number(item.id)
        );
      }

    });


    /*
    |--------------------------------------------------------------------------
    | Stationery
    |--------------------------------------------------------------------------
    */

    this.selectedStationery.forEach(item => {

      if (item?.id) {

        ids.push(
          Number(item.id)
        );
      }

    });


    /*
    |--------------------------------------------------------------------------
    | Remove invalid IDs + duplicates
    |--------------------------------------------------------------------------
    */

    return [
      ...new Set(
        ids
          .map(id => Number(id))
          .filter(id => id > 0)
      )
    ];
  }

    slugify(text: string): string {
    if (!text) return '';
    return text.toString().toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^\w\-]+/g, '')
      .replace(/\-\-+/g, '-')
      .replace(/^-+/, '')
      .replace(/-+$/, '');
  }

}